import callApi from "./callApi";
import { markPendingLogin, reportPendingLogin } from "./pendingLogin";

const reportLogin = (userId: string) => {
  markPendingLogin();
  callApi((api) =>
    Promise.resolve(api.setUserId(userId)).then(() => reportPendingLogin(api)),
  );
};

export default reportLogin;
